import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/features/admin/api/settings.api';

export const settingsKeys = {
    all: ['settings'] as const,
    public: () => [...settingsKeys.all, 'public'] as const,
};

export function usePublicSettings() {
    return useQuery({
        queryKey: settingsKeys.public(),
        queryFn: () => settingsApi.getPublicSettings(), // Use public endpoint instead of admin
        staleTime: 1000 * 60 * 60, // 1 hour - settings don't change often
    });
}
